import React from 'react';
import autobind from 'autobind-decorator';
// import Autocomplete from 'react-autocomplete';
import {service as PermitTypeService} from "../../Services/PermitTypeService";
import Debounce from "debounce-decorator";

export class PermitTypeAutoSelect extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            value: "",
            values: [],
            permitTypes: [],
            permitType: null
        };
    }

    componentDidMount() {
        PermitTypeService.Get()
            .then((x) => {
                this.setState({
                    permitTypes: x.result
                }, () => {
                    if(this.props.Value) {
                        let permitType = this.state.permitTypes.find((y) => y.permitTypeId == this.props.Value);

                        if(permitType) {
                            this.setState({
                                values: [],
                                value: permitType.name,
                                permitType: permitType
                            });
                        }
                    }
                });
            });
    }

    @Debounce(250)
    performSearch() {
        let values = this.state.permitTypes.filter((x) => x.name.includes(this.state.value));
        let headers = [];

        //add headers
        values.forEach((x) => {
            if(!headers.find((y) => y.header == x.PermitOrganization.name)) {
                headers.push({header: x.PermitOrganization.name});
            }
        });

        this.setState({ values: values.concat(headers) });
    }

    @autobind
    getAutocompleteSelectedValueText() {
      if(this.state.permitType) {
        return this.state.permitType.name;
      }
      return "";
    }

    @autobind
    getAutocompleteSubtext() {
        if(this.state.permitType && this.state.permitType.PermitOrganization) {
            return this.state.permitType.PermitOrganization.name;
        }
        return "";
    }

    render() {
        return <div className="autocomplete-column">
            {/* TODO: This component is broken in react 17 */}
            {/*<Autocomplete*/}
                {/*value={this.state.value}*/}
                {/*inputProps={{ className: 'autocomplete-input', placeholder: "Permit Type",*/}
	                {/*onFocus: (event) => {event.target.setSelectionRange(0, -1);  this.performSearch(); },*/}
                    {/*onBlur: (event) => { this.setState({ value: this.getAutocompleteSelectedValueText() }); }*/}
                {/*}}*/}
                {/*wrapperStyle={{ position: 'relative', display: 'inline-block' }}*/}
                {/*items={this.state.values}*/}
                {/*getItemValue={(item) => item.name || item.header}*/}
                {/*onChange={(event, value) => {*/}
                    {/*this.setState({ value: value }, this.performSearch);*/}
                {/*}}*/}
                {/*onSelect={(value, item) => {*/}
                    {/*this.setState({*/}
                        {/*value: value,*/}
                        {/*permitType: item*/}
                    {/*}, () => {*/}
                        {/*this.props.OnUpdate(item.permitTypeId)*/}
                    {/*});*/}
                {/*}}*/}
                {/*renderMenu={children => (*/}
                    {/*<div className="sb-autocomplete-menu">*/}
                        {/*{*/}
                            {/*children.length ?*/}
                                {/*children:*/}
                                {/*(*/}
                                    {/*this.state.value != "" ?*/}
                                        {/*<div className="sb-autocomplete-no-items">*/}
                                            {/*No matching results*/}
                                        {/*</div>:*/}
                                        {/*<div />*/}
                                {/*)*/}
                        {/*}*/}
                    {/*</div>*/}
                {/*)}*/}
                {/*sortItems={(a, b, value) => {*/}
                    {/*let aContext = a.PermitOrganization ? a.PermitOrganization.name: a.header;*/}
                    {/*let bContext = b.PermitOrganization ? b.PermitOrganization.name: b.header;*/}

                    {/*if(aContext != bContext) {*/}
                        {/*return (aContext < bContext ? -1 : 1);*/}
                    {/*} else if (a.header && !b.header) {*/}
                        {/*return -1;*/}
                    {/*} else if (!a.header && b.header) {*/}
                        {/*return 1;*/}
                    {/*} else {*/}
                        {/*return (a.permitTypeId < b.permitTypeId ? 1 : -1);*/}
                    {/*}*/}
                {/*}}*/}
                {/*renderItem={(item, isHighlighted) => (*/}
                    {/*item.header ?*/}
                        {/*<div*/}
                            {/*className={"sb-autocomplete-header-item"}*/}
                            {/*key={item.header}*/}
                        {/*>*/}
                            {/*{item.header}*/}
                        {/*</div>:*/}
                        {/*<div*/}
                            {/*className={"sb-autocomplete-item " + (isHighlighted ? 'item-highlighted' : '')}*/}
                            {/*key={item.permitTypeId}*/}
                        {/*>*/}
                            {/*{item.name}*/}
                        {/*</div>*/}
                {/*)}*/}
                {/*isItemSelectable={(x) => !x.header}*/}
            {/*/>*/}
            <div className="sb-autocomplete-subtext">{this.getAutocompleteSubtext()}</div>
        </div>;
    }
}


